import React from 'react';
import { Quote, Star } from 'lucide-react';
import { containerWide, sectionHeading, sectionSpacing } from '../styles/ui';

const Testimonials = () => {
  const reviews = [
    {
      text: "The quality of the chicken and mutton is outstanding! Every cut is so fresh and tender. I've never found better meat anywhere else!",
      name: "Priya Sharma",
      role: "Regular Customer",
      initials: "PS",
      cardBg: "bg-emerald-50"
    },
    {
      text: "Best meat shop in the area! The cuts are always fresh, prices are honest, and the staff is incredibly friendly. Feels like family!",
      name: "Rajesh Kumar",
      role: "Loyal Customer",
      initials: "RK",
      cardBg: "bg-white border border-emerald-100"
    },
    {
      text: "Fresh & Homely truly delivers on freshness! The seafood selection is amazing and everything is so hygienically packed. Highly recommend!",
      name: "Anita Desai",
      role: "Happy Customer",
      initials: "AD",
      cardBg: "bg-emerald-50"
    },
    {
      text: "Their fish is incredibly fresh! You can tell it's premium quality. The cleanliness and packaging standards are exceptional.",
      name: "Sneha Rao",
      role: "Regular Shopper",
      initials: "SR",
      cardBg: "bg-white border border-emerald-100"
    },
    {
      text: "Affordable prices for such high-quality meat and seafood. The attention to hygiene and freshness is impressive. Very reliable!",
      name: "Vikram Singh",
      role: "Health Enthusiast",
      initials: "VS",
      cardBg: "bg-emerald-50"
    },
    {
      text: "The team is always welcoming and helpful! The meat is always fresh and perfectly cut. This is my go-to meat shop now!",
      name: "Meera K.",
      role: "Local Resident",
      initials: "MK",
      cardBg: "bg-white border border-emerald-100"
    }
  ];

  // Duplicate reviews for seamless scroll
  const allReviews = [...reviews, ...reviews];

  return (
    <section className={`${sectionSpacing} bg-gradient-to-b from-canvas via-white to-canvas overflow-hidden`}>
      <div className={`${containerWide} mb-12`}>
        <div className="text-center">
          <span className="inline-block text-xs font-bold tracking-widest uppercase text-accent-600 mb-3">
            Loved By Our Community
          </span>
          <h2 className={`${sectionHeading} mb-4`}>What Our Families Say</h2>
          <p className="text-ink-secondary">Real experiences from our community members</p>
        </div>
      </div>

      <div className="relative">
        <div className="testimonial-track gap-8 px-4">
          {allReviews.map((review, index) => (
            <div key={index} className={`testimonial-card ${review.cardBg} p-8 rounded-3xl shadow-soft relative`}>
              <div className="text-emerald-300 absolute top-6 right-8 opacity-50">
                <Quote size={40} />
              </div>
              <div className="flex gap-1 text-yellow-500 mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" />
                ))}
              </div>
              <p className={`${review.cardBg.includes('emerald-50') ? 'text-emerald-900' : 'text-ink-secondary'} mb-8 italic`}>
                "{review.text}"
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-primary rounded-full flex items-center justify-center font-bold text-white shadow-glow-teal">
                  {review.initials}
                </div>
                <div>
                  <p className="font-bold text-emerald-950">{review.name}</p>
                  <p className={`text-xs ${review.cardBg.includes('emerald-50') ? 'text-emerald-700' : 'text-ink-secondary'}`}>
                    {review.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
